export default __webpack_public_path__ + "static/media/time-management-circle.677b7b74.png";